import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Button,
  Container
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          textAlign: 'center', 
          mt: 4,
          background: 'linear-gradient(to bottom right, #f44336, #d32f2f)'
        }}
      >
        <ErrorOutlineIcon 
          sx={{ 
            fontSize: 64, 
            color: 'white', 
            mb: 2 
          }} 
        />
        <Typography variant="h4" gutterBottom sx={{ color: 'white' }}>
          Payment Cancelled
        </Typography>
        <Typography 
          variant="body1" 
          sx={{ color: 'white', opacity: 0.9 }} 
          paragraph
        >
          Your payment was cancelled. No charges were made.
        </Typography>
        <Box sx={{ mt: 3 }}>
          <Button 
            variant="contained" 
            onClick={() => navigate('/credits')}
            sx={{ 
              mr: 2,
              bgcolor: 'white',
              color: '#f44336',
              '&:hover': {
                bgcolor: 'rgba(255,255,255,0.9)'
              }
            }}
          >
            Try Again
          </Button>
          <Button 
            variant="outlined" 
            onClick={() => navigate('/dashboard')}
            sx={{ 
              color: 'white',
              borderColor: 'white',
              '&:hover': {
                borderColor: 'rgba(255,255,255,0.9)',
                bgcolor: 'rgba(255,255,255,0.1)'
              }
            }}
          >
            Go to Dashboard
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default PaymentCancel; 